import { render } from "./step6.vue?vue&type=template&id=474153e0"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"

import "./step6.vue?vue&type=style&index=0&id=474153e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__